import { render, staticRenderFns } from "./file_drop_overlay.vue?vue&type=template&id=8958387a&scoped=true&lang=pug"
import script from "./file_drop_overlay.vue?vue&type=script&lang=js"
export * from "./file_drop_overlay.vue?vue&type=script&lang=js"
import style0 from "./file_drop_overlay.vue?vue&type=style&index=0&id=8958387a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8958387a",
  null
  
)

export default component.exports